export default __webpack_public_path__ + "static/media/learn_button_upload.1d9a8307.png";